import { useCallback } from 'react';
import { useSearchParams } from '../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../shared/constants';

const { filters } = shutdownFiltersData;

const generateValidParams = (searchParams) => {
  const params = {};

  searchParams.forEach((value, key) => {
    const filter = filters[key];

    if (filter) {
      if (filter.isValid(value)) {
        params[key] = value;
      } else if (filter.hasOwnProperty('initialValue')) {
        params[key] = filter.initialValue;
      }
    }
  });

  return params;
};

export const useSetDefaultFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setDefaultFilter = useCallback(
    (locationState) => {
      const { period, onlyActive, isNew, fromNotification } = filters;
      const params = generateValidParams(searchParams);

      if (!params.hasOwnProperty(period.name)) {
        params[period.name] = period.initialValue;
      }

      if (!params.hasOwnProperty(onlyActive.name)) {
        params[onlyActive.name] = onlyActive.initialValue;
      }

      if (locationState?.from === 'notifications') {
        params[fromNotification.name] = locationState.id;
        delete params[isNew.name];
      } else {
        delete params[fromNotification.name];
      }

      setSearchParams(params);
    },
    [searchParams, setSearchParams]
  );

  return setDefaultFilter;
};
